import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { TRANSLATION_KEY } from '../constants';
import { formatAlertTime } from '../utils';

const TIME_KEY = `${TRANSLATION_KEY}.TIME`;

const AlertTime = ({ lastRunAt = null, finished = false }) => {
    const time = formatAlertTime(lastRunAt);
    if (!time) return finished ? <Translate id={`${TIME_KEY}.FINISHED`} /> : null;
    return <Translate id={`${TIME_KEY}.${finished ? 'FINISHED_' : ''}${time.key}`} data={time.data} />;
};

AlertTime.propTypes = {
    lastRunAt: PropTypes.string,
    finished: PropTypes.bool,
};

export default AlertTime;
